/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  function initBlogSlider(sectionId) {
    var $swiperEl = $('.js-blog-swiper-' + sectionId);
    if (!$swiperEl.length) return;

    new Swiper($swiperEl[0], {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
        speed: 300,
  resistanceRatio: 0.85,
  touchRatio: 1,
  touchAngle: 45,
  threshold: 3,
  followFinger: true,
  touchStartPreventDefault: false,
  touchMoveStopPropagation: false,
  nested: true,
  freeMode: {
    enabled: true,
    momentum: true,
    momentumRatio: 0.4,
    momentumVelocityRatio: 1,
    momentumBounce: false,
    sticky: false,
    minimumVelocity: 0.02,
  },
  cssMode: false,
  keyboard: { enabled: true, onlyInViewport: true },
  mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
      navigation: {
        prevEl: '.js-blog-prev-' + sectionId,
        nextEl: '.js-blog-next-' + sectionId,
      },
      breakpoints: {
        1279: { spaceBetween: 24 }
      },
      on: {
        init: function () {
          if ($(window).width() <= 800) return;
          var swiperEl = '.js-blog-swiper-' + sectionId;

          ScrollReveal().reveal(swiperEl + ' .swiper-slide', {
            origin: 'bottom',
            distance: '20px',
            duration: 700,
            delay: 0,
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
            opacity: 0,
            scale: 1,
            once: true,
            interval: 40,
            afterReveal: function (el) {
              $(el).css({ visibility: '', opacity: '', transform: '' });
              ScrollReveal().clean(el);
            }
          });
        },
        slideChange: function () {
          if ($(window).width() <= 800) return;
          var swiper = this;
          $(swiper.slides).each(function (i, slide) {
            if ($(slide).css('opacity') === '0') {
              $(slide).css({
                transition: 'none',
                opacity: 1,
                transform: 'translateY(0)',
                visibility: 'visible'
              });
              ScrollReveal().clean(slide);
            }
          });
        }
      }
    });
  }

  if ($(window).width() > 800) {
    ScrollReveal().reveal('.blog-slider__heading', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    ScrollReveal().reveal('.blog-slider__bottom', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
  }

  var instances = window.DeskBlogSlider || {};
  $.each(instances, function (id) {
    initBlogSlider(id);
  });
});